// Attribution for third-party assets shipped with the game. CC-BY / MIT
// licences REQUIRE this credit to be shown to players (Settings → Credits).
// Add one entry per asset (or asset pack) when you ship it.
export interface AssetCredit {
  /** What it is in the game, e.g. "Shark". */
  what: string;
  /** Original title + author. */
  source: string;
  license: "CC0" | "CC-BY 4.0" | "CC-BY 3.0" | "MIT";
  url: string;
}

export const ASSET_CREDITS: AssetCredit[] = [
  {
    what: "Scattered rocks, boulders and bush foliage (photoscans)",
    source: "Poly Haven photoscans: rock_07, rock_09, namaqualand_boulder_05; bush leaves from shrub_03",
    license: "CC0",
    url: "https://polyhaven.com/models",
  },
  {
    what: "Character suit, glove, boot and hat surface detail (photoscans)",
    source: "Poly Haven photoscans: denim_fabric_04, fabric_leather_02, leather_white, brown_leather, caban",
    license: "CC0",
    url: "https://polyhaven.com/textures",
  },
  {
    what: "Daylight sky lighting (HDRI)",
    source: "Kloofendal 48d Partly Cloudy (Pure Sky) by Greg Zaal, Poly Haven",
    license: "CC0",
    url: "https://polyhaven.com/a/kloofendal_48d_partly_cloudy_puresky",
  },
  {
    what: "Map surface textures (walls, ground, paving, roofs, trees, rocks)",
    source: "Poly Haven photoscans: metal_plate_02, white_sandstone_bricks, concrete_wall_004, "
      + "castle_wall_varriation, painted_plaster_wall, weathered_brown_planks, concrete_floor_02, "
      + "concrete_wall_008, concrete_pavement_02, concrete_tiles_02, bark_brown_02, rock_face, "
      + "gravel_concrete, corrugated_iron, forest_leaves_02, rocky_trail, forest_ground_04",
    license: "CC0",
    url: "https://polyhaven.com",
  },
  {
    what: "Zombie body (mesh, rig, textures — repainted as a zombie)",
    source: "Microsoft Rocketbox avatar library: Male_Adult_01, © 2020 Microsoft",
    license: "MIT",
    url: "https://github.com/microsoft/Microsoft-Rocketbox",
  },
  {
    what: "Zombie animations (idle, walk, run, attack, death, hit — retargeted)",
    source: "Male City Zombie by Rikindle3D",
    license: "CC0",
    url: "https://opengameart.org/content/male-city-zombie-ready-for-use-in-game-engines",
  },
  {
    what: "Shark (mesh, rig, swim / bite / circling animations)",
    source: "shark.glb from the Babylon.js Assets library, by Babylon.js",
    license: "CC-BY 4.0",
    url: "https://github.com/BabylonJS/Assets/blob/master/meshes/shark.glb",
  },
  {
    what: "Kraken (octopus mesh, arm rig and eye animations; arm motion is ours)",
    source: "octopus_customRig.glb from the Babylon.js Assets library, by Babylon.js",
    license: "CC-BY 4.0",
    url: "https://github.com/BabylonJS/Assets/blob/master/meshes/octopus_customRig.glb",
  },
  {
    what: "Horse (mesh, rig, saddle and gait animations; coat, mane and tack recoloured by us)",
    source: "\"Horse\" by henry_7 (Sketchfab)",
    license: "CC-BY 4.0",
    url: "https://sketchfab.com/3d-models/horse-a6f860e43e364619bccb174a1ac7d0c9",
  },
];
